export const getDiscounts = state => state.discount.discounts;

export const getDiscountsByPartnerId = (state, partnerId) => {
    if (partnerId) {
        const discounts = getDiscounts(state);
        return discounts[partnerId] ? discounts[partnerId] : [];
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/services/discount/selector.js